// JavaScript Document
var groupId;
$(document).ready(function() {
	
	$('body.training-page .page').height($(window).height()-$('header').outerHeight());
	
	$('.new-group-training').click(function() {
		var $modal = $('<div id="new-group-training-modal" class="reveal" data-reveal></div>');
		$('body').append($modal);
		$modal.foundation();
		$.ajax({
			method: "POST",
			url: '/ajax/accreditation/training/modal-new-group-training',
			contentType : 'application/json',
			data: JSON.stringify({ 
				w: workplaceId
			})
		}).done(function(response){
			$modal.html(response.html).foundation('open');
			$modal.on('closed.zf.reveal', function() {
				$modal.foundation('_destroy').remove();
			});
			$modal.on('submit','#new-training-group-form', function(e) {
				e.preventDefault();
				var $form = $(e.currentTarget);
				var data = $form.serializeObject();
				data.w = workplaceId;
				var $subButton = $form.find('input.submit');
				var subText = $subButton.text();
				var $errors = $form.find('.form-errors');
				$errors.empty().hide();
				$subButton.attr('type','button').html('<span class="icon-sync2 spin"></span>')
				$.ajax({
					method: "POST",
					url: '/ajax/accreditation/training/create-group',
					contentType : 'application/json',
					data: JSON.stringify(data)
				}).done(function(response){
					window.location.href = response.url;
					$('#table_training-groups').DataTable().ajax.reload(null,false);
					$modal.foundation('close');
				}).fail(function(jqXHR, textStatus, errorThrown) {
					$subButton.attr('type','submit').html(subText)
					$errors.text("Sorry, we can't start your Training Session at the moment. Please try again later.").show();
				});
			});
		}).fail(function(jqXHR, textStatus, errorThrown) {
			alert("Sorry, we can't create a new Training Session at the moment. Please try later");
		});
	});
	
	
	$('.onboard-remote-training').click(function() {
		var $modal
		var $csvForm;
		if ($('#onboard-employees-modal').length) {
			$modal = $('#onboard-employees-modal');
			$modal.foundation('open');
		} else {
			$modal = $('<div id="onboard-employees-modal" class="reveal large" data-reveal></div>');
			$('body').append($modal);
			$modal.foundation();
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/modal-onboard-employees',
				contentType : 'application/json',
				data: JSON.stringify({ 
					w: workplaceId
				})
			}).done(function(response){
				$modal.html(response.html).foundation('open');
				$modal.find('.onboarding-accordion').foundation();
				$csvForm = $modal.find('#onboard-employees-csv-form');
				$csvForm.on('change','.onboard-employees-form-element input', function(e) {
					$csvForm.trigger('submit');
				});
			}).fail(function(jqXHR, textStatus, errorThrown) {
				alert("Sorry, we can't onboard your users at the moment due to an error. Please try later");
			});
		}
	});
	
	$(document).on('submit','#onboard-employees-csv-form', function(e) {
		console.log("submitted form");
		e.preventDefault();
		
		var $form = $(e.currentTarget);
		var $errorContainer = $form.find('.form-errors');
		var fd = new FormData(this);
		fd.append('w',workplaceId);
		$.ajax({  
			url: "/ajax/accreditation/training/onboard-employees-csv",  
			method: "POST",  
			data: fd,  
			contentType: false,          // The content type used when sending data to the server.  
			dataType: 'json',          // The content type used when sending data to the server.  
			cache: false,                // To unable request pages to be cached  
			processData: false,          // To send DOMDocument or non processed data file it is set to false  
		}).done(function(response){
			$form[0].reset();
			$('.onboard-employees-csv-upload .ajax-result-info').append('<div class="cell">'+response.message+'</div>');
			if (response.hasOwnProperty('warning')) {
				$('.onboard-employees-csv-upload .ajax-result-info').append('<div class="cell callout warning">'+response.warning+'</div>');
			}
			if (response.hasOwnProperty('elems')) {
				$.each(response.elems,function(i,e) {
					$('.onboard-employees-csv-upload .ajax-result-elems').append('<div class="cell grid-x grid-margin-x onboarding-employee">'+e.email+e.name+response.controls+'</div>');
				})
			}
			$('.onboard-employees-csv-upload .step-1').hide();
			$('.onboard-employees-csv-upload .step-2').show();
			
		}).fail(function(jqXHR, textStatus, errorThrown) {
			var message;
			if (jqXHR.hasOwnProperty('responseJSON') && jqXHR.responseJSON.hasOwnProperty('error')) {
				message = jqXHR.responseJSON.error;
			} else {
				message = 'Sorry, we couldn\'t handle that file due to an error. Please try later';
			}
			$errorContainer.html('<p>'+message+'</p>').show();
		});
	});
	
	$(document).on('click', '.add-onboarding-employee', function(e) {
		var $employeeHolder = $(e.currentTarget).closest('.onboarding-employees');
		var numEmployees = $('.onboarding-employee').length;
		var $onboardingEmployee = $($('.onboarding-employee-template').html());
		$onboardingEmployee.find('input#emailAddress-').attr('id','emailAddress-'+numEmployees).prev().attr('for','emailAddress-'+numEmployees);
		$onboardingEmployee.find('input#name-').attr('id','name-'+numEmployees).prev().attr('for','name-'+numEmployees);
		$onboardingEmployee.appendTo($employeeHolder);
	});
	
	$(document).on('click', '.delete-onboarding-employee', function(e) {
		if (confirm("Are you sure you want to delete this trainee?") ) {
			$(e.currentTarget).closest('.onboarding-employee').remove();
		}
	});
	
	$(document).on('change', '.onboard-employees-csv-upload .ajax-result-elems input', function() {
		$('.onboard-employees-csv-upload').addClass('edited');
	});
	
	$(document).on('click', '.onboard-employees-csv-upload .cancel-uploaded-csv', function() {
		if (!$('.onboard-employees-csv-upload').hasClass('edited') || confirm('Are you sure you want to delete these trainees and upload another CSV file?')) {
			$('.onboard-employees-csv-upload').removeClass('edited');
			$('.onboard-employees-csv-upload .ajax-result-info').empty();
			$('.onboard-employees-csv-upload .ajax-result-elems').empty();
			$('.onboard-employees-csv-upload .step-1').show();
			$('.onboard-employees-csv-upload .step-2, .onboard-employees-csv-upload .step-3').hide();
		}
	});
	
	$(document).on('submit','.onboard-employees-form', function(e) {
		console.log("submitted form");
		e.preventDefault();
		var $modal = $('#onboard-employees-modal');
		var $form = $(e.currentTarget);
		var $errorContainer = $form.find('.form-errors');
		$errorContainer.empty().hide();
		var data = $form.serializeObject();
		data.w = workplaceId;
		console.log(data);
		$.ajax({  
			url: "/ajax/accreditation/training/onboard-employees",  
			method: "POST",  
			contentType : 'application/json',
			data: JSON.stringify(data) 
		}).done(function(response){
			if (response.success) {
				$('.onboard-trainees-container').html(response.message);
				var table = $('#table_training-remote-employees').DataTable();
				table.ajax.reload(null,false);
				$modal.on('closed.zf.reveal', function() {
					$modal.foundation('_destroy').remove();
				});
			} else {
				$form.find('.ajax-result-info').html('<div class="cell">'+response.message+'</div>');
				if (response.hasOwnProperty('warning')) {
					$form.find('.ajax-result-info').append('<div class="cell callout warning">'+response.warning+'</div>');
				}
				if (response.hasOwnProperty('elems')) {
					$form.find('.ajax-result-elems').empty();
					$.each(response.elems,function(i,e) {
						$form.find('.ajax-result-elems').append('<div class="cell grid-x grid-margin-x onboarding-employee">'+e.email+e.name+response.controls+'</div>');
					})
				}
			}
		}).fail(function(jqXHR, textStatus, errorThrown) {
			var message;
			if (jqXHR.hasOwnProperty('responseJSON') && jqXHR.responseJSON.hasOwnProperty('error')) {
				message = jqXHR.responseJSON.error;
			} else {
				message = 'Sorry, we couldn\'t process your users at the moment due to an error. The site administrators have been informed. Please try later';
			}
			$errorContainer.html('<p>'+message+'</p>').show();
		});
	});
	
	$(document).on('click','.launch-employee-training-analysis-modal', function(e) {
		
		if ($('#group-training-analysis-modal').length) {
			var $existingModal = $('#group-training-analysis-modal').foundation();
			$existingModal.foundation('_destroy').remove();
		}
		var employeeId = $(e.currentTarget).data('employee-id');
		var $modal = $('<div id="employee-training-analysis-modal" class="large reveal" data-reveal></div>');
		$modal.data('employee-id', employeeId);
		$('body').append($modal);
		$modal.foundation();
		$.ajax({
			method: "POST",
			url: '/ajax/accreditation/training/modal-employee-training-analysis',
			contentType : 'application/json',
			data: JSON.stringify({ 
				w: workplaceId,
				e: employeeId
			})
		}).done(function(response){
			$modal.html(response.html).foundation('open');
			$modal.on('closed.zf.reveal', function() {
				$modal.foundation('_destroy').remove();
			});
			$modal.on('submit','#update-employee-form', function(e) {
				e.preventDefault();
				var $form = $(e.currentTarget);
				var data = $form.serializeObject();
				data.e = $modal.data('employee-id');
				var $subButton = $form.find('button.submit');
				var subText = $subButton.text();
				var $resultBox = $form.find('.form-result');
				$resultBox.removeClass('alert success').empty().hide();
				$subButton.attr('type','button').html('<span class="icon-sync2 spin"></span>');
				$.ajax({
					method: "POST",
					url: '/ajax/accreditation/training/update-employee',
					contentType : 'application/json',
					data: JSON.stringify(data)
				}).done(function(response){
					if (response.success) {
						$resultBox.text("Trainee Updated").show().addClass('success');
						setTimeout(function() {
							$resultBox.slideUp('fast');
						}, 5000);
						$subButton.attr('type','submit').html(subText);
						$modal.find('.modal-title').html(response.modalTitle);
						$('#table_training-remote-employees').DataTable().ajax.reload(null,false);
					} else {
						$form.find('.form-elems').html(response.formElemsHtml);
					}
				}).fail(function(jqXHR, textStatus, errorThrown) {
					$subButton.attr('type','submit').html(subText)
					$resultBox.text("Sorry, we can't update the group size of your training session at the moment. Please try again later.").show().addClass('alert');
				});
			});
		}).fail(function(jqXHR, textStatus, errorThrown) {
			alert("Sorry, we can't display the trainee analysis at the moment. Please try later");
		});
	});
	
	$(document).on('click','.launch-training-invitation-preview-modal', function(e) {
		var $modal = $('#training-invitation-preview-modal');
		if ($modal.length) {
			$modal.foundation('open');
		} else {
			$modal = $('<div id="training-invitation-preview-modal" class="small reveal" data-reveal></div>');
			$modal.foundation();
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/modal-training-invitation-preview',
				contentType : 'application/json',
				data: JSON.stringify({ 
					w: workplaceId
				})
			}).done(function(response){
				$modal.html(response.html).foundation('open');
			}).fail(function(jqXHR, textStatus, errorThrown) {
				alert("Sorry, we can't display the remote training invitation at the moment. Please try later");
			});
		}
	});
	
	$(document).on('click', '.delete-training-group', function(e) {
		var groupId = $(e.currentTarget).data('training-group-id');
		var $modal = $('<div id="delete-training-group-modal" class="reveal" data-reveal></div>');
		$('body').append($modal);
		$modal.foundation();
		$.ajax({
			method: "POST",
			url: '/ajax/accreditation/training/modal-delete-training-group',
			contentType : 'application/json',
			data: JSON.stringify({ 
				g: groupId
			})
		}).done(function(response){
			$modal.html(response.html).foundation('open');
			$modal.on('closed.zf.reveal', function() {
				$modal.foundation('_destroy').remove();
			});
			$modal.on('submit','#delete-training-group-form', function(e) {
				e.preventDefault();
				var $form = $(e.currentTarget);
				var data = $form.serializeObject();
				var $subButton = $form.find('button.submit');
				var subText = $subButton.text();
				var $errors = $form.find('.form-errors');
				$errors.empty().hide();
				$subButton.attr('type','button').html('<span class="icon-sync2 spin"></span>');
				$.ajax({
					method: "POST",
					url: '/ajax/accreditation/training/delete-group',
					contentType : 'application/json',
					data: JSON.stringify(data)
				}).done(function(response){
					$modal.foundation('close');
					$('#table_training-groups').DataTable().ajax.reload(null,false);
				}).fail(function(jqXHR, textStatus, errorThrown) {
					$subButton.attr('type','submit').html(subText)
					$errors.text("Sorry, we can't delete your session at the moment. Please try again later.").show();
				});
			})
		}).fail(function(jqXHR, textStatus, errorThrown) {
			alert("Sorry, we can't delete your session at the moment. Please try later");
		});
	});
	
	
	
	
	if ($('#group-training-page').length) {
		var $summary = $('#group-training-summary');
		var $qrPreview = $('#group-training-qr-preview');
		var $sections = $('.training-page-section');
		var sectionNum = $sections.not(".hide").last().index();
		//console.log("current section:",sectionNum);
		//var summaryStep = 0;
		groupId = $('#group-training-page').data('training-group-id');
		var groupToken = $('#group-training-page').data('token');
		var headerHeight = $('header').height();
		
		$(window).on('resize', Foundation.util.throttle(function(e){
			headerHeight = $('header').height();
		}, 250));
		
		
		document.addEventListener('visibilitychange', function() {
			refreshGroupSummary(groupId, $summary, $sections);
		});
		
		// click handler for exit button
		$('.exit-training').click(function(e) {
			e.preventDefault();
			var $link = $(e.currentTarget);
			var href = $link.attr('href');
			var html = '<div id="exit-group-training-modal" class="reveal" data-reveal>'+
				'<div class="grid-x grid-padding-x grid-padding-y">'+
					'<div class="cell small-12 white-bg text-center">'+
						'<div class="cell-inner cell-inner-padding-x"><h2>Leave Training Session</h2></div>'+
					'</div>'+
					'<div class="cell small-12 text-center">'+
						'<div class="cell-inner cell-inner-padding-x">'+
							'<p>Are you sure you want to leave the training session?</p>'+
							'<a class="button primary float-left" data-close>Stay in Session</a>'+
							'<a class="button alert float-right" href="'+href+'">Exit Session</a>'+
						'</div>'+
					'</div>'+
				'</div>'+
				'<button class="close-button" aria-label="Dismiss alert" type="button" data-close><span aria-hidden="true">&times;</span></button></div>'+
			'</div>';
			var $modal = $(html);
			$modal.foundation();
			$modal.foundation('open');
			$modal.on('closed.zf.reveal', function() {
				$modal.foundation('_destroy').remove();
			});
		});
		
		// refresh the group summary every 10s
		
		setInterval(function() {
			refreshGroupSummary(groupId, $summary, $sections);
		}, 10000);
		
		// on load, scroll to the last section that isn't hidden or onboarding
		/*$('html, body').animate({
			scrollTop: $sections.not(".hide").last().offset().top - headerHeight
		}, 1000);
		*/
		$('html, body').scrollTop($sections.not(".hide").last().offset().top - headerHeight);
		
		$('.group-training-summary-container').on('click','.training-fullscreen-expand',function() {
			var elem = document.documentElement;
			if (elem.requestFullscreen) {
				elem.requestFullscreen();
			} else if (elem.webkitRequestFullscreen) { /* Safari */
				elem.webkitRequestFullscreen();
			} else if (elem.msRequestFullscreen) { /* IE11 */
				elem.msRequestFullscreen();
			}
			$('.training-fullscreen-controls').addClass('fullscreen');
			$("html, body").animate({ scrollTop: $(document).height() });
		});
		
		$(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
			if (document.fullscreenElement) {
				$('.training-fullscreen-controls').addClass('fullscreen');	
			} else {
				$('.training-fullscreen-controls').removeClass('fullscreen');	
			}
			$("html, body").animate({ scrollTop: $(document).height() });
		});
		
		$('.group-training-summary-container').on('click','.training-fullscreen-contract',function() {
			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.webkitExitFullscreen) { /* Safari */
				document.webkitExitFullscreen();
			} else if (document.msExitFullscreen) { /* IE11 */
				document.msExitFullscreen();
			}
			$('.training-fullscreen-controls').removeClass('fullscreen');
			$("html, body").animate({ scrollTop: $(document).height() });
		});
	
		$('#group-training-summary').on('click','.group-resize',function() {
			var $modal = $('<div id="group-training-resize-modal" class="reveal" data-reveal></div>');
			$('body').append($modal);
			$modal.foundation();
			$modal.on('closed.zf.reveal', function() {
				$modal.foundation('_destroy').remove();
			});
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/modal-group-training-resize',
				contentType : 'application/json',
				data: JSON.stringify({ 
					g: groupId
				})
			}).done(function(response){
				$modal.html(response.html).foundation('open');
			}).fail(function(jqXHR, textStatus, errorThrown) {
				alert("Sorry, we can't create a new Training Session at the moment. Please try later");
			});
		});
	
		$('#group-training-summary').on('click','.edit-employee-name',function(e) {
			var $elem = $(e.currentTarget);
			if (!$elem.hasClass('disabled')) {
				$('#group-training-summary .edit-employee-name').addClass('disabled');
				$elem.removeClass('disabled');
				$elem.closest('tr').addClass('editing');
				$('#group-training-summary').addClass('paused');
			}
		});
	
		$('#group-training-summary').on('click','.cancel-employee-name',function(e) {
			var $elem = $(e.currentTarget);
			var $tr = $elem.closest('tr');
			$tr.removeClass('editing saving');
			$tr.find('.employee-name .error').remove();
			$('#group-training-summary .edit-employee-name').removeClass('disabled');
			$tr.find('input').val($tr.find('.name span').attr('title'));
			$('#group-training-summary').removeClass('paused');
		});
		
		$('#group-training-summary').on('keyup','.employee-name input',function(e) {
			console.log("changed");
			var $input = $(e.currentTarget);
			var $tr = $input.closest('tr');
			var $saveButton = $tr.find('.save-employee-name');
			$tr.find('.employee-name .error').remove();
			if ($input.val() == '') {
				$saveButton.addClass('disabled');
			} else {
				$saveButton.removeClass('disabled');
			}
		});
	
		$('#group-training-summary').on('click','.save-employee-name',function(e) {
			var $elem = $(e.currentTarget);
			if (!$elem.hasClass('disabled')) {
				var $tr = $elem.closest('tr');
				$tr.find('.employee-name .error').remove();
				$tr.addClass('saving');
				var data = {
					name: $tr.find('input').val(),
					g: groupId,
					e: $tr.data('employee-id'),
					csrfToken: groupToken,
					initiator: 'host'
				}
				$.ajax({
					method: "POST",
					url: '/ajax/accreditation/training/update-employee-name',
					contentType : 'application/json',
					data: JSON.stringify(data)
				}).done(function(response){
					$summary.html(response.summaryHtml);
					$('#group-training-summary .edit-employee-name').removeClass('disabled');
					$('#group-training-summary').removeClass('paused');
				}).fail(function(jqXHR, textStatus, errorThrown) {
					$tr.removeClass('saving');
					var message;
					if (jqXHR.hasOwnProperty('responseJSON') && jqXHR.responseJSON.hasOwnProperty('error')) {
						message = jqXHR.responseJSON.error;
					} else {
						message = 'Sorry, we couldn\'t update the trainee\'s name due to an error. Please try later';
					}
					$tr.find('.employee-name').append('<p class="error"><small><span class="alert">'+message+'</span></small></p>');
				});
			}
		});
	
		$('#group-training-summary').on('click','.delete-employee',function(e) {
			var $elem = $(e.currentTarget);
			var $tr = $elem.closest('tr');
			var employeeId = $tr.data('employee-id');
			var employeeName = $tr.find('.name span').attr('title');
			var html = '<div id="confirm-delete-group-employee-modal" class="reveal" data-reveal>'+
				'<div class="grid-x grid-padding-x grid-padding-y" style="font-size:1.2rem">'+
					'<div class="cell small-12 white-bg text-center">'+
						'<div class="cell-inner cell-inner-padding-x"><h2>Remove Trainee</h2></div>'+
					'</div>'+
					'<div class="cell small-12 text-center">'+
						'<div class="cell-inner cell-inner-padding-x cell-inner-padding-y">'+
							'<p>Are you sure you want to remove <strong><span class="accent">'+employeeName+'</span></strong> from the training session?</p>'+
							'<p><span class="alert">YOU CAN\'T UNDO THIS ACTION</span></p>'+
						'</div>'+
					'</div>'+
					'<div class="cell small-12 text-center">'+
						'<a class="button primary float-left" data-close>Cancel</a>'+
						'<a class="button alert float-right confirm-delete-employee" data-employee-id="'+employeeId+'">Delete Trainee</a>'+
					'</div>'+
				'</div>'+
				'<button class="close-button" aria-label="Dismiss alert" type="button" data-close><span aria-hidden="true">&times;</span></button></div>'+
			'</div>';
			var $modal = $(html);
			$modal.foundation();
			$modal.foundation('open');
			$modal.on('closed.zf.reveal', function() {
				$modal.foundation('_destroy').remove();
			});
		});
		
		$(document).on('click','.confirm-delete-employee',function(e) {
			var $button = $(e.currentTarget);
			var buttonText = $button.text();
			var $modal = $button.closest('.reveal');
			var $cell = $button.closest('.cell');
			$cell.find('.submission-errors').remove();
			$button.addClass('disabled').html('<span class="icon-sync2 spin"></span>');
			var data = {
				g: groupId,
				token: groupToken,
				e: $button.data('employee-id')
			}
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/delete-employee',
				contentType : 'application/json',
				data: JSON.stringify(data)
			}).done(function(response){
				$summary.html(response.summaryHtml);
				$modal.foundation('close');
			}).fail(function(jqXHR, textStatus, errorThrown) {
				var message;
				if (jqXHR.hasOwnProperty('responseJSON') && jqXHR.responseJSON.hasOwnProperty('error')) {
					message = jqXHR.responseJSON.error;
				} else {
					message = 'Sorry, we couldn\'t delete the trainee due to an error. Please try later';
				}
				$cell.append('<div class="callout alert"><p>'+message+'</p></div>');
				$button.removeClass('disabled');
				$button.html(buttonText);
			});
		});
		
		
		
	
		$(document).on('submit','#training-group-resize-form', function(e) {
			e.preventDefault();
			var $form = $(e.currentTarget);
			var $modal = $form.closest('.reveal');
			var data = $form.serializeObject();
			data.w = workplaceId;
			data.g = groupId;
			var $subButton = $form.find('input.submit');
			var subText = $subButton.text();
			var $errors = $form.find('.form-errors');
			$errors.empty().hide();
			$subButton.attr('type','button').html('<span class="icon-sync2 spin"></span>');
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/group-resize',
				contentType : 'application/json',
				data: JSON.stringify(data)
			}).done(function(response){
				$modal.foundation('close').foundation('_destroy').remove();
				$summary.html(response.summaryHtml);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				$subButton.attr('type','submit').html(subText)
				$errors.text("Sorry, we can't update the group size of your training session at the moment. Please try again later.").show();
			});
		});
		
		$('#group-training-summary').on('click','.next-section',function(e) {
			var $button = $(e.currentTarget);
			var $section = $sections.filter('[data-section='+sectionNum+']');
			var $nextSection = $section.next();
			
			// cancel any name editing
			$summary.find('.editing .cancel-employee-name').trigger('click');
			$summary.removeClass('paused');
			
			
			if ($nextSection.hasClass('hide')) {
				if($button.hasClass('complete-enrolment')) {
					var total = parseInt($button.data('total-trainees'));
					var onboarded = parseInt($button.data('onboarded-trainees'));
					if ($button.hasClass('disabled') || onboarded < total) {
						if (onboarded == 0) {
							$('#trim-trainees-modal').addClass('zero-onboarded');
						} else {
							$('#trim-trainees-modal').removeClass('zero-onboarded');
						}
						$('#trim-trainees-modal .num-trainees-str').html(onboarded==1?'1 trainee':onboarded+' trainees');
						$('#trim-trainees-modal').foundation('open');
					} else {
						groupTrainingScrollToSection($nextSection);
					}
				} else if ($button.hasClass('video-play-required')) {
					var $modalButton = $section.find('.launch-modal-video');
					if ($modalButton.data('watch-time') >= 90) {
						groupTrainingCompleteSection(workplaceId, groupId, $section.data('section'),groupToken);
						groupTrainingScrollToSection($nextSection);
					} else {
						showVideoRequiredModal(sectionNum);
					}
				} else {
					if($button.hasClass('disabled')) {
						$('#force-completion-modal').foundation('open');
						$('#force-completion-modal').off('click','.force-group-completion');
						$('#force-completion-modal').on('click','.force-group-completion',function() {
							$button.removeClass('disabled');
							$('#force-completion-modal').foundation('close');
							groupTrainingCompleteSection(workplaceId, groupId, $section.data('section'),groupToken);
							groupTrainingScrollToSection($nextSection);
						})
					} else {
						groupTrainingCompleteSection(workplaceId, groupId, $section.data('section'),groupToken);
						groupTrainingScrollToSection($nextSection);
					}
					/*
					$('#force-completion-modal').foundation('open');
					$('#force-completion-modal').off('click','.force-group-completion');
					$('#force-completion-modal').on('click','.force-group-completion',function() {
						groupTrainingCompleteSection(workplaceId, groupId, $section.data('section'),groupToken);
						groupTrainingScrollToSection($nextSection);
					})
					if(!$button.hasClass('disabled') || confirm("Some employees have not yet completed this stage in the training.\n\nAre you sure you want to continue?")) {
						$button.removeClass('disabled');
						groupTrainingCompleteSection(workplaceId, groupId, $section.data('section'),groupToken);
						groupTrainingScrollToSection($nextSection);
					}
					*/
				}
			} else {
				groupTrainingScrollToSection($nextSection)
			}
		});
		
		$(window).on('scroll', Foundation.util.throttle(function(e){
			var scrollTop = $(this).scrollTop();
			var diff;
			var closest = 0;
			$sections.each(function(i,v) {
				var distance = Math.abs(scrollTop - $(v).offset().top);
				if (!$(v).hasClass('hide') && (diff === undefined || diff >= distance)) {
					diff = distance;
					closest = i;
				}
			});
			if (sectionNum != closest) {
				sectionNum = closest;
				//var newSummaryStep = $sections.eq(sectionNum).data('summary-step');
				//console.log("sectionNum changed to:",sectionNum);
				//console.log("newSummaryStep",newSummaryStep);
				// remove any 'step-x' class0
				$summary.removeClass (function (index, className) {
					return (className.match (/(^|\s)step-\S+/g) || []).join(' ');
				}).addClass('step-'+sectionNum);
				$qrPreview.removeClass (function (index, className) {
					return (className.match (/(^|\s)step-\S+/g) || []).join(' ');
				}).addClass('step-'+sectionNum);
				
				/*
				if (newSummaryStep != summaryStep) {
					if ((newSummaryStep>0) != (summaryStep>0)) {
						// visibility of summary change 
						if (newSummaryStep > 0) {
							//console.log("newSummaryStep is "+newSummaryStep+"; showing");
							$summary.removeClass(['step-1','show-step-2','show-step-3','show-step-4','show-step-5']);
							$summary.addClass('show-step-'+newSummaryStep);
							Foundation.Motion.animateIn($summary, 'slide-in-right')
						} else {
							//console.log("newSummaryStep is "+newSummaryStep+"; hiding");
							Foundation.Motion.animateOut($summary, 'slide-out-right')
						}
					}
					summaryStep = newSummaryStep;
				}
				*/
			}
		}, 300));
		
		$('#group-training-summary').on('click','.expand-summary, .minimise-summary', function(e) {
			$summary.toggleClass('minimised');
		})
		
		$(document).on('click','#trim-trainees-modal .trim-group-trainees', function(e) {
			var $button = $(e.currentTarget);
			var $errors = $('#trim-trainees-modal .ajax-errors');
			if (!$button.hasClass('disabled')) {
				var anchorText = $button.html();
				$errors.addClass('hide').empty();
				$button.addClass('disabled').html('<span class="icon-sync2 spin"></span>');
				$.ajax({
					method: "POST",
					url: '/ajax/accreditation/training/trim-group-trainees',
					contentType : 'application/json',
					data: JSON.stringify({
						g: groupId,
						token: groupToken
					})
				}).done(function(response){
					$('#trim-trainees-modal').foundation('close').foundation('_destroy').remove();
					$summary.html(response.summaryHtml);
				}).fail(function(jqXHR, textStatus, errorThrown) {
					$errors.html(errorThrown).removeClass('hide');
					$button.removeClass('disabled').html(anchorText);
				});
			}
		});
		
		
	}
	
	if ($('#group-training-employee-page').length || $('#training-employee-page').length) {
		var $section;
		var employeeToken
		if ($('#group-training-employee-page').length) {
			employeeToken = $('#group-training-employee-page').data('token');
			groupId = $('#group-training-employee-page').data('training-group-id');
			var groupPin = $('#group-training-employee-page').data('training-group-pin');
		
			$('.show-enrolment-option').click(function(e) {
				console.log("change enrolment option");
				var $button = $(e.currentTarget);
				var $container = $button.closest('.trainee-group-enrolment');
				$container.find('.alert').remove();
				console.log("$container",$container);
				if ($button.hasClass('show-enrolment-returning')) {
					$container.removeClass('new').addClass('returning');
					$container.find('.employee-name').addClass('hide');
					$container.find('.employee-id').removeClass('hide');
				} else {
					$container.removeClass('returning').addClass('new');
					$container.find('.employee-name').removeClass('hide');
					$container.find('.employee-id').addClass('hide');
				}
			});

			$('.group-employee-edit').click(function() {
				var $modal = $('<div id="group-employee-edit-modal" class="reveal" data-reveal></div>');
				//$('body').append($modal);
				$modal.foundation();
				$.ajax({
					method: "POST",
					url: '/ajax/accreditation/training/modal-group-employee-edit',
					contentType : 'application/json',
					data: JSON.stringify({ 
						g: groupId,
						p: groupPin
					})
				}).done(function(response){
					$modal.html(response.html).foundation('open');
					$modal.on('closed.zf.reveal', function() {
						$modal.foundation('_destroy').remove();
					});
					$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
				}).fail(function(jqXHR, textStatus, errorThrown) {
					alert("Sorry, an error occurred. Please try later");
				});
			});

			$(document).on('submit','#group-employee-edit-form', function(e) {
				e.preventDefault();
				var $form = $(e.currentTarget);
				var $formErrors = $form.find('.form-errors');
				var data = $form.serializeObject();
				data.g = groupId;
				data.p = groupPin;
				data.initiator = 'employee';
				$formErrors.hide();
				$.ajax({
					method: "POST",
					url: '/ajax/accreditation/training/update-employee-name',
					contentType : 'application/json',
					data: JSON.stringify(data)
				}).done(function(response){
					$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
					$('#group-employee-edit-modal').foundation('close');
				}).fail(function(jqXHR, textStatus, errorThrown) {
					var message;
					if (jqXHR.hasOwnProperty('responseJSON') && jqXHR.responseJSON.hasOwnProperty('error')) {
						message = jqXHR.responseJSON.error;
					} else {
						message = 'Sorry, we couldn\'t update your name due to an error. Please try later';
					}
					$formErrors.html(message).show();
				});
			});
			
		} else {
			employeeToken = $('#training-employee-page').data('token');
			
		
			$('.next-section').click(function(e) {
				var $button = $(e.currentTarget);
				$section = $button.closest('.training-page-section');
				var $nextSection = $section.next();
				var sectionNum = $section.data('section');
				console.log(sectionNum);

				if ($nextSection.hasClass('hide') && $button.hasClass('video-unplayed')) {
					showVideoRequiredModal(sectionNum);
				} else if ($nextSection.hasClass('hide')) {
					employeeCompleteSection($section);
				} else {
					console.log("Scrolling to ",$nextSection);
					employeeScrollToSection($nextSection);
				}
			});
		}
			
		
		// keep the session alive while group training
		setInterval(keepAlive, 300000);
		/*if (!$('#group-training-employee-page').length) {
			$("html, body").animate({ scrollTop: $(document).height() }, 500);
		}*/
		$('html, body').scrollTop($(document).height());
		
		
		
		
		$('.launch-survey').click(function(e) {
			var $button = $(e.currentTarget);
			$section = $button.closest('.training-page-section');
			var surveyType = $button.data('survey-type');
			if ($('#training-survey-modal').length) {
				$('#training-survey-modal').foundation('open');
			} else {
				var $modal = $('<div id="training-survey-modal" class="reveal" data-reveal data-close-on-click="false" data-close-on-esc="false"></div>');
				$('body').append($modal);
				$modal.foundation();
				$.ajax({
					method: "POST",
					url: '/ajax/accreditation/training/survey',
					contentType : 'application/json',
					data: JSON.stringify({
						type: surveyType
					})
				}).done(function(response){
					$modal.html(response.modalHtml).foundation('open');
					var $form = $modal.find('form');
					var $errors = $form.find('.form-errors');
					var $content = $form.find('.modal-content');
					$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
					$form.submit(function(e) {
						e.preventDefault();
						$errors.empty().hide();
						var data = $form.serializeObject();
						data.type = $form.data('survey-type');
						data.token = employeeToken;
						$.ajax({
							method: "POST",
							url: '/ajax/accreditation/training/survey',
							contentType : 'application/json',
							data: JSON.stringify(data)
						}).done(function(response){
							if (response.complete) {
								// we can now complete the section and allow the user to progress
								$('#training-survey-modal').foundation('close').foundation('_destroy').remove();
								$('header').find('.progress-meter').width(response.coursePc+'%');
								employeeCompleteSection($section);
							} else {
								$content.html(response.html);
								$form.find('.progress-meter').width(response.pc+'%');
								$('header').find('.progress-meter').width(response.coursePc+'%');
								$('html, body, .reveal-overlay, .reveal').animate({
									scrollTop: 0
								}, 500);
							}
							$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
						}).fail(function(jqXHR, textStatus, errorThrown) {
							switch (jqXHR.status) {
								case 400:
									$errors.html(errorThrown).show();
								break;
								case 401:
									showEmployeeSessionErrorModal()
								break;
								default:
									$errors.html('Sorry, we couldn&rsquo;t save your answer. Please reload the page and try again or contact support').show();
							}
						});
					});
					
					// change handler to activate/deactivate subsequent questions when a radio button is changed
					$modal.on('change', '.field-multicheckbox', function(e) {
						var $input = $(e.currentTarget);
						var noneOfAboveQuestion = false;
						var noneOfAboveAnswer = false;
						var $question = $input.closest('.survey-multicheckbox-question');
						// check all options in the question to see if any contain None of the above
						$question.find('input').each(function(i,q) {
							var optionText = $(q).next('.field-label-text').text();
							if (optionText.includes('None of the above') || optionText == 'This is not applicable for us') {
								noneOfAboveQuestion = true;
							}
						});

						var optionText = $input.next('.field-label-text').text();
						if ($input.prop('checked') && (optionText.includes('None of the above') || optionText == 'This is not applicable for us')) {
							noneOfAboveAnswer = true;
						}

						if (noneOfAboveQuestion) {
							// if this question has a 'none of the above' option, make sure the mutually exclusive ones are unchecked
							$question.find('input').each(function(i,q) {
								var optionText = $(q).next('.field-label-text').text();
								if ((noneOfAboveAnswer && !optionText.includes('None of the above') && optionText != 'This is not applicable for us') ||  (!noneOfAboveAnswer && optionText.includes('None of the above') || optionText == 'This is not applicable for us')) {
									$(q).prop('checked', false);
								}
							});
						}
					});
					
				}).fail(function(jqXHR, textStatus, errorThrown) {
					switch (jqXHR.status) {
						case 401:
							showEmployeeSessionErrorModal();
						break;
						default:
							$modal.html('<div class="grid-x grid-padding-x grid-padding-y"><div class="cell"><p>Sorry, we couldn&rsquo;t load the form. Please try later</p><a class="button primary" onClick="window.location.reload();">Try Again</a></div></div>').foundation('open');
					}
				});
			}
		});
		
		
		$(document).on('click', '#employee-survey-form .prev', function(e) {
			var $form = $('#employee-survey-form');
			var $errors = $form.find('.form-errors');
			var $content = $form.find('.modal-content');
			var data = {
				prevQ: $(e.currentTarget).data('q'),
				type: $form.data('survey-type'),
				token: employeeToken
			};
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/survey',
				contentType : 'application/json',
				data: JSON.stringify(data)
			}).done(function(response){
				$content.html(response.html);
				$form.find('.progress-meter').width(response.pc+'%');
				$('header').find('.progress-meter').width(response.coursePc+'%');
				$('html, body, .reveal-overlay, .reveal').animate({
					scrollTop: 0
				}, 500);
				$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				switch (jqXHR.status) {
					case 400:
						$errors.html(errorThrown).show();
					break;
					case 401:
						showEmployeeSessionErrorModal();
					break;
					default:
						$errors.html('Sorry, we couldn&rsquo;t save your answer. Please reload the page and try again or contact support').show();
				}
			});
		});
		
		$('.launch-risk-assessment').click(function(e) {
			var $button = $(e.currentTarget);
			$section = $button.closest('.training-page-section');
			if ($('#training-risk-assessment-modal').length) {
				$('#training-risk-assessment-modal').foundation('open');
			} else {
				var $modal = $('<div id="training-risk-assessment-modal" class="reveal" data-reveal data-close-on-click="false" data-close-on-esc="false"></div>');
				$('body').append($modal);
				$modal.foundation();
				$.ajax({
					method: "GET",
					url: '/ajax/accreditation/training/risk-assessor',
					contentType : 'application/json'
				}).done(function(response){
					$modal.html(response.modalHtml).foundation('open');
					var $skinTypeQ = $modal.find('.skin-type-container');
					if ($skinTypeQ.length) {
						console.log("re init foundation");
						$modal.foundation();
					}
					$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
				}).fail(function(jqXHR, textStatus, errorThrown) {
					switch (jqXHR.status) {
						case 401:
							showEmployeeSessionErrorModal();
						break;
						default:
							$modal.html('<div class="grid-x grid-padding-x grid-padding-y"><div class="cell"><p>Sorry, we couldn&rsquo;t load the Risk Assessment. Please try later</p><a class="button primary" onClick="window.location.reload();">Try Again</a></div></div>').foundation('open');
					}
				});
			}
		});
		
		$(document).on('submit','#employee-risk-assessor-form', function(e) {
			e.preventDefault();
			var $form = $(this);
			var $errors = $form.find('.form-errors');
			var $content = $form.find('.modal-content');
			$errors.empty().hide();
			var data = $form.serializeObject();
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/risk-assessor',
				contentType : 'application/json',
				data: JSON.stringify(data)
			}).done(function(response){
				if (response.complete) {
					// we can now complete the section and allow the user to progress
					$('#training-risk-assessment-modal').foundation('close').foundation('_destroy').remove();
					$('header').find('.progress-meter').width(response.coursePc+'%');
					employeeCompleteSection($section);
				} else {
					$content.html(response.html);
					$('header').find('.progress-meter').width(response.coursePc+'%');
					$form.find('.progress-meter').width(response.pc+'%');
					$('html, body, .reveal-overlay, .reveal').animate({
						scrollTop: 0
					}, 500);
				}
				$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				switch (jqXHR.status) {
					case 400:
						$errors.html(errorThrown).show();
					break;
					case 401:
						showEmployeeSessionErrorModal();
					break;
					default:
						$errors.html('Sorry, we couldn&rsquo;t save your answer. Please reload the page and try again or contact support').show();
				}
			});
		});
		
		$(document).on('click', '#employee-risk-assessor-form .prev', function(e) {
			var $form = $('#employee-risk-assessor-form');
			var $errors = $form.find('.form-errors');
			var $content = $form.find('.modal-content');
			var data = {
				prevC: $(e.currentTarget).data('c')
			};
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/risk-assessor',
				contentType : 'application/json',
				data: JSON.stringify(data)
			}).done(function(response){
				$content.html(response.html);
				$form.find('.progress-meter').width(response.pc+'%');
				$('header').find('.progress-meter').width(response.coursePc+'%');
				$('html, body, .reveal-overlay, .reveal').animate({
					scrollTop: 0
				}, 500);
				$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
			}).fail(function(jqXHR, textStatus, errorThrown) {
				switch (jqXHR.status) {
					case 400:
						$errors.html(errorThrown).show();
					break;
					case 401:
						showEmployeeSessionErrorModal();
					break;
					default:
						$errors.html('Sorry, we couldn&rsquo;t save your answer. Please reload the page and try again or contact support').show();
				}
			});
		});
		
		$(document).on('change', '.risk-assessor-question input', function(e) {
			var $input = $(this);
			var $question = $input.closest('.risk-assessor-question');
			if ($question.hasClass('skin-type-question')) {
				//console.log("skin type question change");
				var alertId = $input.data('alert');
				$question.find('.risk-assessor-alert').each(function(i,v) {
					//console.log("comparing "+$(v).data('alert')+" to "+alertId);
					if($(v).data('alert') == alertId) {
						$(v).removeClass('hide');
					} else {
						$(v).addClass('hide');
					}
				})
			} else {
				if ($input.data('triggers-alert')) {
					$question.find('.risk-assessor-alert').removeClass('hide');
				} else {
					$question.find('.risk-assessor-alert').addClass('hide');
				}
			}
		});
		
		$('.launch-i-spy-melanoma').click(function(e) {
			var $button = $(e.currentTarget);
			$section = $button.closest('.training-page-section');
			if ($('#training-i-spy-melanoma-modal').length) {
				$('#training-i-spy-melanoma-modal').foundation('open');
			} else {
				var $modal = $('<div id="training-i-spy-melanoma-modal" class="large reveal" data-reveal data-close-on-click="false" data-close-on-esc="false" data-v-offset="0"></div>');
				$('body').append($modal);
				$modal.foundation();
				$.ajax({
					method: "GET",
					url: '/ajax/accreditation/training/ism-slide',
					contentType : 'application/json'
				}).done(function(response){
					$modal.html(response.modalHtml).foundation('open');
					$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
				}).fail(function(jqXHR, textStatus, errorThrown) {
					switch (jqXHR.status) {
						case 401:
							showEmployeeSessionErrorModal();
						break;
						default:
							$modal.html('<div class="grid-x grid-padding-x grid-padding-y"><div class="cell"><p>Sorry, we couldn&rsquo;t load the I Spy Melanoma Challenge. Please try later</p><a class="button primary" onClick="window.location.reload();">Try Again</a></div></div>').foundation('open');
					}
				});
			}
		});
		
		$(document).on("click",'#training-i-spy-melanoma-modal .next-ism-slide', function(e) {
			var $button = $(e.currentTarget);
			if (!$button.hasClass('activated')) {
				$button.addClass('activated')
				showNextIsmSlide(e);
			}
		});
		
		$('#group-training-employee-page .next-section').click(function(e) {
			var $nextSection = $(e.currentTarget).closest('.training-page-section').next();
			employeeScrollToSection($nextSection)
		});
		
		$('#group-training-employee-page .complete-section').click(function(e) {
			var $button = $(e.currentTarget);
			$section = $button.closest('.training-page-section');
			console.log("complete-section");
			employeeCompleteSection($section);
		});
		
		$(document).on('click','#training-survey-modal .complete-survey', function(e) {
			$section = $('.training-page-section').not(".hide").last();
			$('#training-survey-modal').foundation('close').foundation('_destroy').remove();
			employeeCompleteSection($section);
		});
		
		$(document).on('click','#training-i-spy-melanoma-modal .complete-challenge', function(e) {
			$section = $('.training-page-section').not(".hide").last();
			$('#training-i-spy-melanoma-modal').foundation('close').foundation('_destroy').remove();
			employeeCompleteSection($section);
		});
		
		$(document).on('change','.skin-type-question .field-radio', function(e) {
			$('.reveal-overlay, #training-risk-assessment-modal').animate({
				scrollTop: Math.max($('#training-risk-assessment-modal')[0].scrollHeight, $('.reveal-overlay')[0].scrollHeight)
			}, 750);
		});
		
		
		document.addEventListener('visibilitychange', function() {
			// on visibility change, scroll to the bottom
			//$("html, body").animate({ scrollTop: $(document).height() });
			//$("html, body").scrollTop($(document).height());
			
		});
		
	}
		
	$(document).on('click','.resend-onboarding-email',function(e) {
		var $button = $(e.currentTarget);
		$button.addClass('disabled').html('<span class="icon-sync2 spin"></span>');
		var data = {
			w: $button.data('workplace-id'),
			token: $button.data('token'),
			e: $button.data('employee-id')
		}
		$.ajax({
			method: "POST",
			url: '/ajax/accreditation/training/resend-onboarding-email',
			contentType : 'application/json',
			data: JSON.stringify(data)
		}).done(function(response){
			$('.invitation-sent-date').html('<p>Sent on '+response.status+' <span class="success icon-checkmark-circle"></span></p>');
			$button.remove();
		}).fail(function(jqXHR, textStatus, errorThrown) {
			$button.removeClass('disabled');
			$('.invitation-sent-date').html('<span class="alert">Failed to send. Please check the email address and try again.</span>');
		});
	});
	
	$(document).on('click','.delete-trainee',function(e) {
		if (confirm("Are you sure you want to delete this trainee?") ) {
			var $button = $(e.currentTarget);
			$button.addClass('disabled').html('<span class="icon-sync2 spin"></span>');
			var data = {
				w: $button.data('workplace-id'),
				token: $button.data('token'),
				e: $button.data('employee-id')
			}
			$.ajax({
				method: "POST",
				url: '/ajax/accreditation/training/delete-employee',
				contentType : 'application/json',
				data: JSON.stringify(data)
			}).done(function(response){
				var table = $('#table_training-remote-employees').DataTable();
				table.ajax.reload(null,false);
				$button.closest('.grid-x').html('<p>Trainee deleted.</p>');
			}).fail(function(jqXHR, textStatus, errorThrown) {
				console.log('trainee delete failed');
				$button.removeClass('disabled').html('Delete Trainee');
				$button.prev().html(errorThrown);
			});			
		}
	});
	
	$(document).on('click','.launch-group-training-analysis-modal', function(e) {
		
		var groupId = $(e.currentTarget).data('training-group-id');
		var $modal = $('<div id="group-training-analysis-modal" class="large reveal" data-reveal></div>');
		$modal.data('group-id', groupId);
		$('body').append($modal);
		$modal.foundation();
		$.ajax({
			method: "POST",
			url: '/ajax/accreditation/training/modal-group-training-analysis',
			contentType : 'application/json',
			data: JSON.stringify({ 
				w: workplaceId,
				g: groupId
			})
		}).done(function(response){
			$modal.html(response.html).foundation('open');
			var table = $('#table_training-group-employees').DataTable({
				ajax: '/ajax/tables/training-group-employees?w='+workplaceId+'&g='+groupId,
				searching: false,
				lengthChange: false
			});
			table.ajax.reload(null,false);
			$modal.on('closed.zf.reveal', function() {
				$modal.foundation('_destroy').remove();
			});
		}).fail(function(jqXHR, textStatus, errorThrown) {
			alert("Sorry, we can't display the trainee analysis at the moment. Please try later");
		});
	});
	
	$(document).on('click', '.send-training-files, .resend-training-files', function(e) {
		
		if ($('.resent-email-flag').length) {
			$('.resent-email-flag').remove();
		}
		
		var $button = $(e.currentTarget);
		var buttonText = $button.html();
		$button.addClass('disabled').html('<span class="icon-sync2 spin"></span>');
		$.ajax({
			method: "POST",
			url: '/ajax/accreditation/training/send-training-files',
			contentType : 'application/json',
			data: JSON.stringify({ 
				employeeId: $(e.currentTarget).data('e')
			})
		}).done(function(response){
			if ($('#success-modal').length) {
				var $existingModal = $('#success-modal').foundation();
				$existingModal.foundation('_destroy').remove();
			}
			
			if ($button.hasClass('send-training-files')) {
			
				$('.training-page-section-content').find('h1').find('.accent').text('WE’VE SENT YOUR FILES');

				$('.training-email > p:first').html('We have sent you an email which provides access to your<br class="show-for-medium"> Certificate of Completion, your Personal Risk Assessment<br class="show-for-medium"> and further supportive information.');

				$('.files-sent-buttons').show();
				$('.pre-files-sent-buttons').hide();
			
				$button.remove();
				
			} else {
				$('.training-resend-email > p').after('<p class="resent-email-flag"><strong>Email resent</strong><span style="margin-left:5px;" class="icon-checkmark-circle success"></span></p>');
				$button.removeClass('disabled');
				$button.html(buttonText);
			}
			
		}).fail(function(jqXHR, textStatus, errorThrown) {
			alert("Sorry, we can't send your files at the moment. Please try later");
			
			$button.removeClass('disabled');
			$button.html(buttonText);
		});
		
	})
	
	$('.training-files-method').on('click', function(e) {
		if ($('.training-download').is(':visible')) {
			$('.training-download').hide();
			$('.training-email').show();
		} else {
			$('.training-email').hide();
			$('.training-download').show();			
		}
	})
	
	$('#email-files-form').on('submit', function(e) {
		e.preventDefault();
		var $form = $(e.currentTarget);
		var data = $form.serializeObject();
		//data.e = $modal.data('employee-id');
		var $subButton = $form.find('button[type="submit"]');
		var $resultBox = $form.find('.form-result');
		$resultBox.removeClass('alert success').empty().hide();
		$subButton.attr('type','button').html('<span class="icon-sync2 spin"></span>');


		$.ajax({
			method: "POST",
			url: '/ajax/accreditation/training/send-training-files',
			contentType : 'application/json',
			data: JSON.stringify({ 
				employeeId: data.employeeId,
				email: data.emailAddress,
				confirmEmail: data.confirmEmailAddress
			})
		}).done(function(response){
			
			$(e.currentTarget).remove();
			$('.training-page-section-content').find('h1').find('.accent').text('WE’VE SENT YOUR FILES');
			
			$('.training-email > p:first').html('We have sent you an email which provides access to your<br class="show-for-medium"> Certificate of Completion, your Personal Risk Assessment<br class="show-for-medium"> and further supportive information.');

			$('.files-sent-buttons').show();
			$('.pre-files-sent-buttons').hide();
			
			/*$modal.find('.cell-inner').html('<h2>Email sent</h2><p>Please check your inbox to download your training files</p>');
			$button.data('email-exists', 1);*/
		}).fail(function(jqXHR, textStatus, errorThrown) {
			
			$subButton.attr('type','submit').html('Send my Files');
			
			var responseJSON = jqXHR.responseJSON;
			if (typeof responseJSON != 'undefined') {
				$(e.currentTarget).find('.error').text(responseJSON.error).show();
			} else {
				$(e.currentTarget).find('.error').text('Sorry, something went wrong. Please try again later.').show();
			}
		});

	});

	$('.training-files-trouble').on('click', function(e) {
		if ($('.training-email').is(':visible')) {
			$('.training-email').hide();
			$('.training-resend-email').show();
		} else {
			$('.training-email').show();
			$('.training-resend-email').hide();
		}
	});
	
	
	if ($('#group-training-page').length || $('#training-employee-page').length) {
		var trainingVideos = [];
		var savePlayerPc;
		
		$('.launch-modal-video').each(function(i, e) {
			
			i++;
			
			console.log(i);
			var options = {
				url: $(e).data('video-url'),
				playsinline: true
			};

			trainingVideos[i] = new Vimeo.Player('vimeo-video-'+i, options);
			
			var $modal = $('#video-modal-'+i);
			
			
			trainingVideos[i].on('play', function() {
				if (!$modal.is(":visible")) {
					console.log("Modal not visible");
					$modal.foundation('open');				
				}
			});

			trainingVideos[i].on('ended', function() {
				exitFullscreen();
				console.log($modal);
				$modal.foundation('close');
			});
		
		
			$modal.on('closed.zf.reveal', function() {
				console.log('closing modal');
				clearInterval(savePlayerPc);
				//$modal.foundation('_destroy').remove();
				$modal.foundation('close');
				trainingVideos[i].pause();
				//trainingVideos[i].element.src = trainingVideos[i].element.src;
			});
		})
		
	}
	
	
		
	$('.launch-modal-video').click(function(e) {
		
		var $modalButton = ($(e.currentTarget));
		
		var videoNumber = $modalButton.data('video-number');
		
		var $modal = $('#video-modal-'+videoNumber);
		var player = trainingVideos[videoNumber];
		player.disablePictureInPicture = true;
		$modal.foundation('open');
		
		player.play().then(function() {
			
			
			$modal.closest('.reveal-overlay').addClass('light-grey-bg');
			var current;
			var duration;
			
			// Update watch time percentage as a data attribute every 250ms
			savePlayerPc = setInterval(function() {
						
				
				//console.log($modal.is(":visible"));
				
				player.getCurrentTime().then(function(seconds) {
					current = seconds;
				});
				player.getDuration().then(function(seconds) {
					duration = seconds;
				});				
				
				var percentage = Math.ceil((current/duration)*100);
				if (isNaN(percentage)) {
					percentage = 0;
				}
				console.log("Watch percentage", percentage);
				
				// Only update watch time if current percentage is greater then the stored percentage
				if (percentage > $modalButton.data('watch-time') || $modalButton.data('watch-time') == undefined) {
					console.log("Watch percentage", percentage);
					$modalButton.data('watch-time', percentage);
				}
				
				var $nextSectionButton = $modalButton.closest('.training-page-section').find('.next-section');
				
				if ($nextSectionButton.hasClass('video-unplayed') && $modalButton.data('watch-time') >= 90) {
					// call the function to record the video as watched if necessary
					if ($('#training-employee-page').length) {
						recordTrainingVideoWatched($modalButton.data('training-video-id'));
					}
					$nextSectionButton.removeClass('video-unplayed');
				}
				
			}, 250);
		}).catch(function(error) {
			switch (error.name) {
				case 'PasswordError':
					console.log("video is password protected");
				break;
				case 'PrivacyError':
					console.log("video is private");
				break;
				default:
					console.log("Error: "+error.name+" - "+error.message);
				break;
			}
		});
		/*player.on('pause', function() {
			
			if ($(window).width() < 1024) {			
				$modal.foundation('close');
				exitFullscreen();	
			}
		});*/
		
	});
	
});

// If browser supports it, exit full screen
function exitFullscreen() {
    var isInFullScreen = (document.fullscreenElement && document.fullscreenElement !== null) ||
        (document.webkitFullscreenElement && document.webkitFullscreenElement !== null) ||
        (document.mozFullScreenElement && document.mozFullScreenElement !== null) ||
        (document.msFullscreenElement && document.msFullscreenElement !== null);

	if (isInFullScreen) {
		if (document.exitFullscreen) {
				document.exitFullscreen();
		} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
		} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
		} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
		}
	}

	
}

function showEmployeeSessionErrorModal() {
	
	var $modal = $('<div id="training-survey-modal" class="reveal" data-reveal data-close-on-click="false" data-close-on-esc="false"></div>');
	var modalMessage;
	var modalHtml;
	$('body').append($modal);
	$modal.foundation();
	
	if ($('#group-training-employee-page').length) {
		modalMessage = '<h3>Your session has expired</h3><p>This could be due to a period of extended inactivity or loss of connection, but could also be due to multiple trainees enroling as the same person.</p><p>Please reload the page and re-enrol before continuing with the training</p>';
	} else {
		modalMessage = '<h3>Your session has expired</h3><p>This could be due to a period of extended inactivity or loss of connection, but could also be due to multiple trainees enroling as the same person.</p><p>Please reload the page and re-enrol before continuing with the training</p>';
	}
	modalHtml = '<div class="grid-x grid-padding-x grid-padding-y"><div class="cell tgext-center">'+modalMessage+'<a class="button primary" onClick="window.location.reload();">Reload</a></div></div>';
	$modal.html(modalHtml).foundation('open');
}

function showVideoRequiredModal(stepNumber) {
	
	var $modal = $('<div class="reveal" data-reveal data-close-on-click="false" data-close-on-esc="false"></div>');
	$('body').append($modal);
	$modal.foundation();
	var modalHtml = '<div class="grid-x grid-padding-x grid-padding-y"><div class="cell text-center"><p>Please watch the short film in full before moving onto the next step</p><a class="button primary play-video">Play Video</a></div></div>';
	$modal.html(modalHtml).foundation('open');
	$modal.on('click', '.play-video', function() {
		$modal.foundation('close').foundation('_destroy').remove();
		$('.training-page-section').eq(stepNumber).find('.launch-modal-video').trigger('click');
	})
}

function refreshGroupSummary(groupId, $summary, $sections) {
	if (document.visibilityState === 'visible' && !$summary.hasClass('paused')) {
		var data = {
			g: groupId
		};
		$.ajax({
			method: "POST",
			url: '/ajax/accreditation/training/group-summary',
			contentType : 'application/json',
			data: JSON.stringify(data)
		}).done(function(response) {
			//console.log(response);
			if (response.authenticated) {
				if ($('.session-error').length) {
					$('.session-error').foundation('close').foundation('_destroy').remove();
				}
				//console.log("Session kept alive, resolving");
				$summary.html(response.summaryHtml);
				$sections.each(function(i,v) {
					if (response.currentSection > i) {
						$(v).find('.next-section').removeClass('disabled');
					}
				});
			} else {
				if (!$('.session-error').length) {
					var $modal = $(response.loginModal);
					$modal.foundation();
					$modal.foundation('open');
					//console.log("session died, rejecting");
				}
			}
		}).fail(function(jqXHR, textStatus, errorThrown) {
			//console.log(errorThrown);
		});
	}
}

function groupTrainingCompleteSection(workplaceId,groupId,s,t) {
	var data = {
		w: workplaceId,
		g: groupId,
		s: s,
		token: t
	};
	$.ajax({
		method: "POST",
		url: '/ajax/accreditation/training/complete-section',
		contentType : 'application/json',
		data: JSON.stringify(data)
	}).done(function(response) {
		$('#group-training-summary').html(response.summaryHtml);
		var $prog = $('#session-progress');
		var currentPC = $prog.width() / $prog.parent().width() * 100;
		var sectionPC = response.coursePc;
		if (sectionPC > currentPC) {
			//console.log("animating percentage to "+sectionPC+"%");
			$prog.animate({
				width: sectionPC+"%"
			}, 200);
		}
	}).fail(function(jqXHR, textStatus, errorThrown) {
		//console.log(errorThrown);
	});
}

function groupTrainingScrollToSection($nextSection) {
	//console.log("$nextSection",$nextSection);
	
	$nextSection.removeClass('hide');
	var $prog = $('#session-progress');
	var currentPC = $prog.width() / $prog.parent().width() * 100;
	console.log(currentPC);
	$('html, body').animate({
		scrollTop: $nextSection.offset().top - $('header').outerHeight()
	}, 1000, 'swing', function() {		
		if ($nextSection.is(':last-child')) {
			$('.training-page-section').slice(0,-1).remove();
		}
	});
}

function employeeCompleteSection($section) {
	console.log('employeeCompleteSection');
	$section.find('.next-section').removeClass('hide');
	$section.find('.section-action').addClass('hide');
	var $nextSection = $section.next();
	$nextSection.removeClass('hide');
	employeeScrollToSection($nextSection);
}
function employeeScrollToSection($nextSection) {
	$('html, body').animate({
		scrollTop: $nextSection.offset().top
	}, 1000, 'swing', function() {	
		console.log('index',$nextSection.index());
		if ($('#group-training-employee-page').length) {
			// for group employee sessions, remove the previous section as soon as each section is completed
			$('.training-page-section').not(".hide").slice(0,-1).remove()
		} else if ($nextSection.is(':last-child')) {
			// for remote employee sessions, remnove all but the last section if it has been reached
			$('.training-page-section').slice(0,-1).remove();
		}
	});
}

function recordTrainingVideoWatched(videoId) {
	var data = {
		videoId: videoId,
	};
	$.ajax({
		method: "POST",
		url: '/ajax/accreditation/training/watched-training-video',
		contentType : 'application/json',
		data: JSON.stringify(data)
	}).done(function(response) {
		console.log("video watch recorded");
	}).fail(function(jqXHR, textStatus, errorThrown) {
		//console.log(errorThrown);
	});
}

function showNextIsmSlide(e) {
	var $container = $('#ism-container');
	var $slideContent = $('.slide-content');
	var currentIsmSlideNum = $container.data('current-ism-slide');
	var nextIsmSlideNum = currentIsmSlideNum + 1;
	var backgroundDone = false;
	var textDone = false;
	
	if (e !== null) {
		$(e.currentTarget).addClass('disabled');
	}
	
	var data = {
		s:nextIsmSlideNum
	};
	if (e !== null && $(e.currentTarget).hasClass('donated')) {
		data.donated = true;
	}
	
	$.ajax({
		method: "POST",
		url: '/ajax/accreditation/training/ism-slide',
		contentType : 'application/json',
		data: JSON.stringify(data)
	}).done(function(response) {
		$('.enroled-as-label .group-employee-edit').html(response.editNameAnchorText);
		$container.data('current-ism-slide',nextIsmSlideNum);
		$('header').find('.progress-meter').width(response.coursePc+'%');
		// successful retrieval
		$('.interactive-content').html('');
		$slideContent.html('');
		//console.log(response);
		if (response.slide.containerClass) {
			$container.attr('class','container').addClass(response.slide.containerClass);
		} else {
			$container.attr('class','container');
		}
		// reset any interactive content event handlers
		
		
		// show interactive content if we have it
		if (response.slide.interactiveContent) {
			//console.log("has interactive content");
			// stash the curret slide content
		
			$('.interactive-content img').removeClass('selected');
			$('.interactive-content').css("opacity",0);
			$.each(response.slide.interactiveContent.images, function( index, value ) {
				//console.log(value);
				$('.interactive-content').append('<img class="'+(value.class?value.class:'')+' notReady image'+index+'" src="'+value.imageUrl+'"'+(value.correct?' data-correct="true"':'')+' />');
			});
			$.each(response.slide.interactiveContent.socialLinks, function( index, value ) {
				//console.log(value);
				$('.interactive-content').append(value);
			});
			$('.interactive-content').animate({opacity: 1},1500);
			
			$container.off('click','img.interactive');
			$container.on("click",'img.interactive', function(ie) {
				var $img = $(ie.currentTarget);
				if (!$img.hasClass('selected') && !$img.hasClass('notReady')) {
					$('.interactive-content img').css('z-index',1);
					$img.css('z-index',2).addClass('selected');
					if ($img.data('correct')) {
						$slideContent.html(response.slide.interactiveContent.correctHtml);
					} else {
						$slideContent.html(response.slide.interactiveContent.incorrectHtml);
					}
				}
			});
			
			$container.off('click','.try-again');
			$container.on("click",'.try-again', function(e) {
				var $img = $('.interactive-content img.selected');
				$img.removeClass('selected');
				//console.log("content",response.slide.placeholderHtml);
				$slideContent.html(response.slide.placeholderHtml);
				$slideContent.find('span').css('opacity',1);
			});
		}
		
		fadeIsmBackground(response.slide.backgroundImages, function() {
			//console.log("started callback");
			// background fade has downloaded first image and any background fade effects have now started
			// populate the content container with the new HTML
			$slideContent.html(response.slide.placeholderHtml);
			displayIsmText(function(){
				// text typing is finished, 
				textDone = true;
				completeFade(textDone,backgroundDone);
			});
		}, function() {
			//console.log("completed callback");
			// background fade has completed
			backgroundDone = true;
			completeFade(textDone,backgroundDone);					
		});

		var completeFade = function(textDone,backgroundDone) {
			if (textDone && backgroundDone) {
				// remove the not ready class on any interactive images
				$('.interactive-content img').removeClass('notReady');
				if ($('.ism-button.hidden').length) {
					$('.ism-button.hidden').animate({opacity: 1},1000,function() {
						$(this).removeClass('hidden');
					});
				}
				if (response.slide.autoProceed) {
					//console.log("text and background done for slide "+currentIsmSlideNum+", transitioning in "+response.slide.autoProceedDelay+"ms");
					setTimeout(function () { 
						showNextIsmSlide(null); 
					}, response.slide.autoProceedDelay);
				}
			}
		}
	}).fail(function(jqXHR, textStatus, errorThrown) {
		switch (jqXHR.status) {
			case 401:
				showEmployeeSessionErrorModal();
			break;
			default:
				alert("Sorry, we were unable to process the request. Please try later");
				if (e !== null) {
					$(e.target).removeClass('disabled');
				}
		}
	});
	
}

function fadeIsmBackground(imagesArray, onStart, onComplete) {
	var $bgImageHolder = $('.background-images');
	var currentIsmSlideNum = $('#ism-container').data('current-ism-slide');
	// mark all images from previous slides as expired
	$bgImageHolder.find('div').addClass('expired');
	var fadeImage = function(index) {
		//console.log("considering image:",index);
		if (index < imagesArray.length) {
			// create placeholder div
			$bgImageHolder.append('<div class="ajax-slide ajax-slide-'+currentIsmSlideNum+' image-'+index+'"></div>');
			var bgimage = new Image();
			var imgSrc = '/images/accreditation/training/i-spy-melanoma/backgrounds/'+imagesArray[index].imageUrl 
			bgimage.src=imgSrc;
			//console.log("loading image:",index);
			$(bgimage).on("load",function(){
				//console.log("image loaded:",index);
				if (index === 0) {
					// once the first image has downloaded, run the started callback
					onStart();
				}
				//console.log("fading in image over "+imagesArray[index].fadeDuration+"ms");
				$('.ajax-slide-'+currentIsmSlideNum+'.image-'+index)
					.css("background-image","url("+imgSrc+")")
					.animate(
						{opacity: 1},
						imagesArray[index].fadeDuration,
						function() {
							//console.log("image faded");
							// remove any images from previous slides
							if (index === 0) {
								$bgImageHolder.find('.expired').remove();
							}
							index++;
							fadeImage(index);
						}
					);
			});
		} else {
			onComplete();
		}
	};
	fadeImage(0);
}

function displayIsmText(callback) {
	var numBlocks = $('span.print').length;
	//console.log("found "+numBlocks+" blocks");
			
	var typeText = function(i) {
		if (i < numBlocks) {
			var duration = 0,
					pauseOnCompletion = 50;
			var span = $('span.print:eq('+i+')');
			if (span.data("pause") > 0) {
				pauseOnCompletion = span.data("pause");
			}
			if (span.data("duration") > 0) {
				duration = span.data("duration");
			}
			i++;
			span.animate(
				{opacity: 1},
				{duration: duration},
				setTimeout(function () { typeText(i); }, pauseOnCompletion)
			);
		} else {
			callback();
		}
	};
	typeText(0);
}